import React from 'react';
import PropTypes from 'prop-types';
import styled from 'styled-components';

const getHeightSize = (size) => {
  if (size === 'small') {
    return '18px';
  } else if (size === 'medium') {
    return '24px';
  } else {
    return '32px';
  }
};
const getWidthSize = (size) => {
  if (size === 'small') {
    return '12px';
  } else if (size === 'medium') {
    return '16px';
  } else {
    return '24px';
  }
};

const Container = styled.div`
  display: inline-flex;
  align-items: center;
  height: ${(props) => getHeightSize(props.size)};
  width: ${(props) => getWidthSize(props.size)};
`;

const Drag = ({ style, className, size, color, accessibilityLabel }) => {
  return (
    <Container
      data-testid="drag-icon"
      size={size}
      style={style}
      className={className}
    >
      <svg
        width="100%"
        role="img"
        height="100%"
        viewBox="0 0 8 12"
        xmlns="http://www.w3.org/2000/svg"
      >
        <title>{accessibilityLabel}</title>
        <path
          d="M3.25 10.5C3.25 11.325 2.575 12 1.75 12C0.925 12 0.25 11.325 0.25 10.5C0.25 9.675 0.925 9 1.75 9C2.575 9 3.25 9.675 3.25 10.5ZM1.75 4.5C0.925 4.5 0.25 5.175 0.25 6C0.25 6.825 0.925 7.5 1.75 7.5C2.575 7.5 3.25 6.825 3.25 6C3.25 5.175 2.575 4.5 1.75 4.5ZM1.75 0C0.925 0 0.25 0.675 0.25 1.5C0.25 2.325 0.925 3 1.75 3C2.575 3 3.25 2.325 3.25 1.5C3.25 0.675 2.575 0 1.75 0ZM6.25 3C7.075 3 7.75 2.325 7.75 1.5C7.75 0.675 7.075 0 6.25 0C5.425 0 4.75 0.675 4.75 1.5C4.75 2.325 5.425 3 6.25 3ZM6.25 4.5C5.425 4.5 4.75 5.175 4.75 6C4.75 6.825 5.425 7.5 6.25 7.5C7.075 7.5 7.75 6.825 7.75 6C7.75 5.175 7.075 4.5 6.25 4.5ZM6.25 9C5.425 9 4.75 9.675 4.75 10.5C4.75 11.325 5.425 12 6.25 12C7.075 12 7.75 11.325 7.75 10.5C7.75 9.675 7.075 9 6.25 9Z"
          fill={color}
        />
      </svg>
    </Container>
  );
};

Drag.propTypes = {
  className: PropTypes.string,
  style: PropTypes.object,
  size: PropTypes.oneOf(['small', 'medium', 'large']),
  color: PropTypes.string,
  accessibilityLabel: PropTypes.string,
};

Drag.defaultProps = {
  className: undefined,
  style: undefined,
  size: 'medium',
  accessibilityLabel: '',
};

export default Drag;
